import * as Sentry from '@sentry/react'

import { axios, endpoints } from '~/settings'
import { nocodbInstance } from '~/settings/axios'

export const fetchApi = {
  sendLogToServer: async (hash, eventData) => {
    if (!hash) return
    try {
      await axios.post(endpoints.virtualRooms.LOG(hash), eventData)
    } catch (err) {
      Sentry.captureException(new Error(`LOG API Failed on event: ${eventData.event}`))
    }
  }
}

export const fetchNocoDB = {
  createIssue: async (issue) => {
    if (!issue) return
    try {
      await nocodbInstance.post(process.env.REACT_APP_NOCODB_ISSUE_URL, issue)
    } catch (err) {
      Sentry.captureException(new Error(`NocoDB Failed on issue: ${issue}`))
    }
  }
}